module.exports = {
    connection: function() {
        switch(process.env.REACT_APP_ENV){
            case 'staging':
                return {
                    serverUrl: 'http://yoga.mugics.com:9000',
                    clientUrl: 'http://yoga.mugics.com:3000'
                };

            case 'production':
                return {
                    serverUrl: 'https://app.mugics.com',
                    clientUrl: 'https://www.mugics.com'
                };

            default:
                // http://localhost:9000
                return {
                    serverUrl: 'http://localhost',
                    clientUrl: 'http://localhost:3000'
                    // TODO: this is only for testing directly on staging
                    // serverUrl: 'http://yoga.mugics.com:9000',
                    // clientUrl: 'http://yoga.mugics.com'
                };
        }
    },
    clientMedia: function() {
        if (process.env.REACT_APP_ENV === 'production'){
            return 'https://media.mugics.com';
        }

        return 'https://s3.eu-central-1.amazonaws.com/mugics-events-images-new';
    },
    defaultLocation: {
        name: 'Tel Aviv',
        lat: 32.0683353,
        lng: 34.7763763
    },
    defaults: {
        chosenLabel: 'Today',
        maxPrice: 200,
        initialPrice: 200,
        lat: 32.0683353,
        lng: 34.7763763,
        mainCities: {
            'Israel': {
                name: 'Tel Aviv',
                lat: 32.0683353,
                lng: 34.7763763
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/Config/Settings.js